import React, {useEffect} from 'react'
import Container, {ContainerProps} from '@mui/material/Container'
import styled from 'styled-components'
import cookies from 'js-cookie'
import containerStyles from './crnt_locale.styles'

interface ObjLang {
  code: string
  direction: string
  name: string
}
interface ApCrntLocaleProps extends ContainerProps {
  locales: ObjLang[]
}

const apAtomName = {ap_atom_name: 'crntLocaleAtom'}

const CrntLocaleAtom = styled((props: ApCrntLocaleProps) => {
  const crntLocale: string = cookies.get('i18next') || 'en'
  const {locales} = props
  const crntLang: ObjLang = locales.find((l: ObjLang) => l.code === crntLocale)

  useEffect(() => {
    document.body.dir = crntLang.direction
  }, [crntLang])
  return <Container {...apAtomName} {...props} />
})`
  ${containerStyles}
`

export default CrntLocaleAtom
